import { forwardRef } from "react";
import { Select } from "@mantine/core";
import useIsDesktop from "../../../hooks/useIsDesktop";

const CustomSelect = forwardRef(
  (
    {
      labelProps = {
        style: { fontWeight: "700" },
        className: "text-neutral-500",
      },
      comboboxProps,
      size,
      lockOnSelect = false,
      searchable,
      clearable,
      value,
      ...props
    },
    ref,
  ) => {
    const isDesktop = useIsDesktop();
    const responsiveSize = size ?? (isDesktop ? "md" : "sm");
    const safeComboboxProps = {
      position: "bottom",
      hideDetached: false,
      keepMounted: false,
      middlewares: { flip: false, shift: false },
      ...comboboxProps,
    };

    const hasValue = !!value;
    const resolvedSearchable = lockOnSelect && hasValue ? false : searchable;
    const resolvedClearable = lockOnSelect && hasValue ? true : clearable;

    return (
      <Select
        labelProps={labelProps}
        ref={ref}
        size={responsiveSize}
        comboboxProps={safeComboboxProps}
        value={value}
        searchable={resolvedSearchable}
        clearable={resolvedClearable}
        {...props}
      />
    );
  },
);

export default CustomSelect;
